module.exports = __webpack_public_path__ + "img/1458313486.5d6ad572.jpg";